import { ApiService } from '../shared/services/api-service/api.service';
import { IVoucherDetails, IVoucherPayload } from './interfaces/voucher.interfaces';

class VoucherServiceClass {
    private static _instance: VoucherServiceClass;
    public static get instance() {
        return this._instance || (this._instance = new this());
    }
    private constructor() { }

    /**
     * Method to get voucher details
     * @param partnerName
     * @param hotelCode
     * @param voucherCode
     */
    async getVoucherDetails(partnerName: string, hotelCode: number, voucherCode: string): Promise<IVoucherDetails> {
        const voucherPayload: IVoucherPayload = {
            'hotelId': hotelCode,
            'voucherStatusRequest': {
                'code': voucherCode
            }
        };
        try {
            const voucherDetailsResponse = await ApiService.getVoucherDetails(partnerName, voucherPayload);
            const voucherDetails: IVoucherDetails = await voucherDetailsResponse.json();
            return voucherDetails;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const VoucherService = VoucherServiceClass.instance;
